module.exports = __webpack_public_path__ + "static/img/core_code.b0c8c83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/comm/assets/image/core_code.jpg
// module id = b9ji
// module chunks = 20